import React from 'react';

import { Box, Flex, Switch, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface ToolStatusSectionProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export function ToolStatusSection({ enabled, onToggle }: ToolStatusSectionProps) {
  const { t } = useTranslation();

  return (
    <Box
      p="md"
      sx={(theme) => ({
        backgroundColor: 'white',
        border: `1px solid ${theme.colors.gray[2]}`,
        borderLeft: `3px solid ${enabled ? theme.colors.green[4] : theme.colors.gray[3]}`
      })}>
      <Flex justify="space-between" align="center">
        <Box>
          <Text fw={600} size="sm" mb={2} c="dark.8">
            Tool Status
          </Text>
          <Text size="sm" c={enabled ? 'green.7' : 'gray.6'}>
            {enabled
              ? t('SMART_ASSISTANT.TOOLS_SECTION.STATUS.ENABLED.DESCRIPTION')
              : t('SMART_ASSISTANT.TOOLS_SECTION.STATUS.DISABLED.DESCRIPTION')}
          </Text>
        </Box>
        <Flex align="center" gap="sm">
          <Text size="sm" fw={500} c={enabled ? 'green.7' : 'gray.6'}>
            {enabled
              ? t('SMART_ASSISTANT.TOOLS_SECTION.STATUS.ENABLED.TITLE')
              : t('SMART_ASSISTANT.TOOLS_SECTION.STATUS.DISABLED.TITLE')}
          </Text>
          <Switch
            checked={enabled}
            onChange={(event) => onToggle(event.currentTarget.checked)}
            color="dark"
            size="md"
          />
        </Flex>
      </Flex>
    </Box>
  );
}
